import { AlphaRCircleIcon } from './AlphaRCircleIcon';

/**
 * author: Contributors
 * id A0CA4573-5B82-4760-BB23-7D1413DE7257
 * name alpha-r-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-r-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterRCircleIcon = AlphaRCircleIcon;
export default LetterRCircleIcon